import { render, staticRenderFns } from "./ModalEditEvol.vue?vue&type=template&id=550162eb&"
import script from "./ModalEditEvol.vue?vue&type=script&lang=js&"
export * from "./ModalEditEvol.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditEvol.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports